import React from 'react';

import { Button } from 'antd';

import { DownloadOutlined } from '@ant-design/icons';

import './AboutCompany.css';

const AboutCompany = () => {
    return (
        <div className="about-page">
            <div className="about-grid">
                {/* Общая информация */}
                <section className="about-card">
                    <h2 className="about-card-title">ООО «Пактема»</h2>
                    <p className="about-card-sub">Оператор платформы «Агропогода»</p>
                    <div className="about-row">
                        <span className="about-label">Полное название</span>
                        <span>Общество с ограниченной ответственностью «Пактема»</span>
                    </div>
                    <div className="about-row">
                        <span className="about-label">Сокращённое название</span>
                        <span>ООО «Пактема»</span>
                    </div>
                    <div className="about-row">
                        <span className="about-label">ОГРН</span>
                        <span>1257000000861</span>
                    </div>
                    <div className="about-row">
                        <span className="about-label">ИНН</span>
                        <span>7000023681</span>
                    </div>
                    <div className="about-row">
                        <span className="about-label">КПП</span>
                        <span>700001001</span>
                    </div>
                </section>

                {/* Банковские реквизиты */}
                <section className="about-card">
                    <h3 className="about-card-heading">Банковские реквизиты</h3>
                    <div className="about-row">
                        <span className="about-label">Расчётный счёт</span>
                        <span className="about-mono">40702810420000182413</span>
                    </div>
                    <div className="about-row">
                        <span className="about-label">Банк</span>
                        <span>ООО «Банк Точка»</span>
                    </div>
                    <div className="about-row">
                        <span className="about-label">БИК</span>
                        <span className="about-mono">044525104</span>
                    </div>
                    <div className="about-row">
                        <span className="about-label">Корр. счёт</span>
                        <span className="about-mono">30101810745374525104</span>
                    </div>
                </section>

                {/* Адреса и контакты */}
                <section className="about-card">
                    <h3 className="about-card-heading">Адреса и контакты</h3>
                    <div className="about-row">
                        <span className="about-label">Юридический адрес</span>
                        <span>
                            634033, Россия, г. Томск, ул. Энергетиков, д. 15, кв. 73
                        </span>
                    </div>
                    <div className="about-row">
                        <span className="about-label">Офис</span>
                        <span>634055, г. Томск, пр. Академический, ½</span>
                    </div>
                    <div className="about-row">
                        <span className="about-label">Email</span>
                        <span>
                            <a href="mailto:info@pactema.com">info@pactema.com</a>
                        </span>
                    </div>
                    <div className="about-row">
                        <span className="about-label">Поддержка</span>
                        <span>
                            <a href="mailto:support@agropogoda.com">support@agropogoda.com</a>
                        </span>
                    </div>
                </section>
            </div>

            <div className="about-docs">
                <h3 className="about-docs-title">Документы</h3>
                <div className="about-docs-list">
                    <Button
                        icon={<DownloadOutlined />}
                        href="https://agropogoda.com/static/files/privacy.pdf"
                        download
                        size="large"
                    >
                        Политика обработки персональных данных
                    </Button>
                    <Button
                        icon={<DownloadOutlined />}
                        href="https://agropogoda.com/static/files/public_offer.pdf"
                        download
                        size="large"
                    >
                        Публичная оферта
                    </Button>
                    <Button
                        icon={<DownloadOutlined />}
                        href="https://agropogoda.com/static/files/payment.pdf"
                        download
                        size="large"
                    >
                        Реквизиты компании
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default AboutCompany;
